import React, { useContext } from 'react';
import './App.css';
import ScoreboardContextProvider, { ScoreboardContextType, ScoreboardContext } from './ScoreboardProvider';
import ThemeContextProvider from './ThemeProvider';
import Root from './views/Root';

function App() {
  return (
    <div className="App">
      <ScoreboardContextProvider>
        <ThemeContextProvider>
          <Test></Test>
          <Root />
        </ThemeContextProvider>
      </ScoreboardContextProvider>
    </div>
  );
}

function Test(){
  const { data, refresh } = useContext(ScoreboardContext) as ScoreboardContextType;
  return <div></div>
}

export default App;
